import React from 'react'
import {
  Grid,
  Col,
  Row,
  ButtonToolbar,
  ToggleButtonGroup,
  ToggleButton,
} from 'react-bootstrap'
import {
  CFXProFormatNumber,
  CalculatorCol,
  FormattedDate,
} from '../../helpers/formatting'
import {connect} from 'react-redux'
import {defaultNumbersFor} from '../../helpers/defaultNumbers'
import {HEIFER_INDEX, STEER_INDEX, REGEX} from '../../constants'
import {
  saveProjection,
  updateProjection,
  replaceAllDefaults,
} from '../../actions'
import {withRouter} from 'react-router'
import CFXProReactCollapsible from '../cfxProReactCollapsible'
import {
  projectionFinishedDateAsString,
  projectionFeedlotCostOfGain,
  projectionGrossCostPerHead,
  projectionMarketPrice,
} from '../../helpers/calculators/projectionCalculations'
import {feedValuesClosestToDate} from '../../helpers/calculators/sharedCalculations'
import {buildLastUpdateFooter} from '../../helpers/textbuilders'
import {parseApiStringDateToDate} from '../../helpers/feedParser'
import {updateDefaultNumbers} from '../../reducers'
import {PROJECTION_UPDATE_DEFAULT_NUMBER} from '../../actionTypes'
import api from '../../api'
import {SyncableButton} from '../../helpers/button'
import {syncDefaultNumbers, syncUserData} from '../../helpers/syncing'
import _ from 'lodash'

var priceProjectionsSavedDefaultsTimeout

@withRouter
@connect((state) => {
  const {
    app: {isLoggedIn},
    userData: {projections, userId},
    data: {dtn, basis},
    defaultNumbers,
  } = state

  return {
    projections,
    isLoggedIn,
    userId,
    defaultNumbers,
    dtnFeedData: dtn,
    basisValues: basis,
  }
})
@api
class PriceProjectionsCalculator extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      type: 0,
      saleDate: '',
      sellingWeight: '',
      costOfBarley: '',
      isActive: true,
      syncingProjection: false,
      syncingDefaults: false,
      didSaveDefaults: false,
      // Deep Copy the object in full
      localDefaultNumbers: JSON.parse(
        JSON.stringify(this.props.defaultNumbers),
      ),
    }
  }

  componentWillMount() {
    const {
      match: {
        params: {id = null},
      },
      projections,
    } = this.props

    if (id && projections[id]) {
      const {type, saleDate, sellingWeight, costOfBarley} = projections[id]
      this.setState({
        type,
        saleDate,
        sellingWeight,
        costOfBarley,
      })
    }
  }

  onValueChanged = (id, value, sender = null) => {
    if (_.includes(id, 'Date')) {
      value = FormattedDate(value)
    }

    if (id in this.state) {
      this.setState({[id]: value})
    } else {
      if (sender != null && !sender.target.validity.valid) {
        return
      }

      const {type, sellingWeight, localDefaultNumbers} = this.state
      const newDefaultNumbers = updateDefaultNumbers(localDefaultNumbers, {
        type: PROJECTION_UPDATE_DEFAULT_NUMBER,
        payload: {
          data: {
            key: id === 'finishedWeight' ? 'outWeight' : id,
            value,
            type: type === HEIFER_INDEX ? 'heifer' : 'steer',
            inWeight: sellingWeight,
          },
        },
      })

      this.setState({localDefaultNumbers: newDefaultNumbers})
    }
  }

  calculate(defaults, projection) {
    const {localDefaultNumbers} = this.state
    const {dtnFeedData, basisValues} = this.props

    if (
      !this.isFilledProjection(projection) ||
      dtnFeedData == null ||
      basisValues == null ||
      localDefaultNumbers == null
    ) {
      return {
        finishedDate: '',
        feedlotCostOfGain: '',
        grossCostPerHead: '',
        projectedMarketPricePerLb: '',
      }
    }

    return {
      finishedDate: projectionFinishedDateAsString(defaults, projection),
      feedlotCostOfGain: projectionFeedlotCostOfGain(defaults, projection),
      grossCostPerHead: projectionGrossCostPerHead(
        defaults,
        projection,
        dtnFeedData,
        basisValues,
      ),
      projectedMarketPricePerLb: projectionMarketPrice(
        defaults,
        projection,
        dtnFeedData,
        basisValues,
      ),
    }
  }

  localSaveProjection() {
    const projection = Object.assign({}, this.state)
    if (!this.isFilledProjection(projection)) {
      alert('Please fill out all fields!')
      return
    }

    const {
      projections,
      isLoggedIn,
      userId,
      apiInstance,
      dispatch,
      history,
      match: {
        params: {id = null},
      },
    } = this.props

    const defaults = this.defaultsForProjection(projection)
    const calcValues = this.calculate(defaults, projection)

    const fullProjection = {
      id: id === null ? this.nextId(projections) : id,
      ...projection,
      ...calcValues,
    }

    delete fullProjection['syncingProjection']
    delete fullProjection['syncingDefaults']
    delete fullProjection['didSaveDefaults']
    delete fullProjection['localDefaultNumbers']

    if (isLoggedIn) {
      fullProjection.userId = userId
      this.setState({syncingProjection: true})
      syncUserData(apiInstance, fullProjection, dispatch, 'Price Projection')
        .then((response) => {
          this.setState({syncingProjection: false})
          history.goBack()
        })
        .catch((err) => {
          this.setState({syncingProjection: false})
        })
    } else {
      if (id === null) {
        dispatch(saveProjection(fullProjection))
      } else {
        dispatch(updateProjection(fullProjection))
      }
      history.goBack()
    }
  }

  localSaveDefaults = () => {
    const {localDefaultNumbers} = this.state
    const {isLoggedIn, apiInstance, userId} = this.props

    if (isLoggedIn) {
      localDefaultNumbers.userId = userId
      this.setState({syncingDefaults: true})
      syncDefaultNumbers(apiInstance, localDefaultNumbers)
        .then((response) => {
          this.updateReduxWithDefaults(localDefaultNumbers)
          this.setState({syncingDefaults: false})
        })
        .catch(() => {
          this.setState({syncingDefaults: false})
        })
    } else {
      this.updateReduxWithDefaults(localDefaultNumbers)
    }
  }

  updateReduxWithDefaults = () => {
    const {localDefaultNumbers} = this.state
    const {dispatch} = this.props
    dispatch(replaceAllDefaults(localDefaultNumbers))
    this.setState({didSaveDefaults: true})
    clearTimeout(priceProjectionsSavedDefaultsTimeout)
    priceProjectionsSavedDefaultsTimeout = setTimeout(() => {
      this.setState({didSaveDefaults: false})
    }, 2000)
  }

  nextId(projections) {
    const projectionIds = Object.keys(projections)

    var lowestProjectionId = -1
    if (projectionIds.length > 0) {
      lowestProjectionId = Math.min(...projectionIds)

      if (lowestProjectionId == null || lowestProjectionId > 0) {
        lowestProjectionId = -1
      } else {
        lowestProjectionId -= 1
      }
    }
    return lowestProjectionId
  }

  isFilledProjection(projection) {
    return (
      projection.saleDate !== null &&
      projection.saleDate !== '' &&
      projection.sellingWeight !== null &&
      projection.sellingWeight !== '' &&
      projection.costOfBarley !== null &&
      projection.costOfBarley !== ''
    )
  }

  defaultsForProjection(projection) {
    return defaultNumbersFor(
      this.state.localDefaultNumbers,
      'projection',
      projection.type === HEIFER_INDEX ? 'heifer' : 'steer',
      projection.sellingWeight,
    )
  }

  render() {
    const {
      dtnFeedData,
      basisValues,
      syncingProjection,
      syncingDefaults,
      match: {
        params: {id = null},
      },
    } = this.props
    const {didSaveDefaults} = this.state

    const projection = Object.assign({}, this.state)
    const defaults = this.defaultsForProjection(projection)

    const {
      finishedDate,
      feedlotCostOfGain,
      grossCostPerHead,
      projectedMarketPricePerLb,
    } = this.calculate(defaults, projection)

    const {liveCattle, cdn} = feedValuesClosestToDate(
      finishedDate,
      dtnFeedData,
      basisValues,
    )

    return (
      <div className="cfx-projections-calculator">
        <Grid>
          <h1 className="text-center">Price Projection</h1>
          <PriceProjectionsInput
            type={projection.type}
            saleDate={projection.saleDate}
            sellingWeight={projection.sellingWeight}
            costOfBarley={projection.costOfBarley}
            onValueChanged={this.onValueChanged}
          />
          <CFXProReactCollapsible title="Default Numbers">
            <PriceProjectionsDefaultNumbers
              finishedDate={finishedDate}
              feedlotCostOfGain={feedlotCostOfGain}
              finishedWeight={defaults.outWeight}
              grossCostPerHead={grossCostPerHead}
              projectedMarketPricePerLb={projectedMarketPricePerLb}
              syncingDefaults={syncingDefaults}
              didSaveDefaults={didSaveDefaults}
              saveDefaults={this.localSaveDefaults}
              onValueChanged={this.onValueChanged}
            />
          </CFXProReactCollapsible>
          <CFXProReactCollapsible title="Results" open={true}>
            <PriceProjectionsResults
              projectedMarketPricePerLb={projectedMarketPricePerLb}
            />
          </CFXProReactCollapsible>
          <Row>
            <SyncableButton
              className="cfxpro__btn-default btn btn-default"
              style={{width: '75%', display: 'block', margin: '1em auto'}}
              isSyncing={syncingProjection}
              isUpdate={id != null}
              baseTitle="Price Projection"
              onClick={() => this.localSaveProjection()}
            />
          </Row>
          <Row>
            <div className="cfx-rt-table">
              <div className="cfx-rt-footer">
                {buildLastUpdateFooter(
                  'LC Futures price is as of (date) at (time)',
                  liveCattle == null
                    ? null
                    : parseApiStringDateToDate(liveCattle.lastUpdated),
                )}
                <br />
                {buildLastUpdateFooter(
                  'CDT and CDN $ is as of (date) at (time)',
                  cdn == null
                    ? null
                    : parseApiStringDateToDate(cdn.lastUpdated),
                )}
              </div>
            </div>
          </Row>
        </Grid>
      </div>
    )
  }
}

export default PriceProjectionsCalculator

class PriceProjectionsInput extends React.Component {
  render() {
    const {
      type,
      saleDate,
      sellingWeight,
      costOfBarley,
      onValueChanged,
    } = this.props

    return (
      <div>
        <Row>
          <Col>
            <ButtonToolbar>
              <ToggleButtonGroup
                id="type"
                type="radio"
                name="options"
                value={type}
                onChange={(e) => onValueChanged('type', e)}
              >
                <ToggleButton value={HEIFER_INDEX}>
                  {type === HEIFER_INDEX && (
                    <i style={{paddingRight: '10px'}} className="fa fa-check" />
                  )}Heifer
                </ToggleButton>
                <ToggleButton value={STEER_INDEX}>
                  {type === STEER_INDEX && (
                    <i style={{paddingRight: '10px'}} className="fa fa-check" />
                  )}Steer
                </ToggleButton>
              </ToggleButtonGroup>
            </ButtonToolbar>
          </Col>
        </Row>
        <Row style={{padding: '10px 0'}}>
          <CalculatorCol
            id="saleDate"
            type="date"
            label="Sale Date"
            placeholder="yyyy-mm-dd"
            value={saleDate}
            max="9999-12-31"
            onChange={(e) => onValueChanged('saleDate', e.target.value, e)}
          />
          <CalculatorCol
            id="sellingWeight"
            type="number"
            label="Sale Weight"
            placeholder="lbs"
            value={sellingWeight}
            onChange={(e) => onValueChanged('sellingWeight', e.target.value)}
          />
          <CalculatorCol
            id="costOfBarley"
            type="number"
            label="Cost of Barley $/Tonne"
            placeholder="$"
            value={costOfBarley}
            onChange={(e) => onValueChanged('costOfBarley', e.target.value)}
          />
        </Row>
      </div>
    )
  }
}

class PriceProjectionsDefaultNumbers extends React.Component {
  render() {
    const {
      finishedDate = null,
      feedlotCostOfGain = null,
      finishedWeight = null,
      grossCostPerHead = null,
      projectedMarketPricePerLb = null,
      syncingDefaults,
      didSaveDefaults,
      saveDefaults,
      onValueChanged,
    } = this.props

    return (
      <div>
        <Row>
          <CalculatorCol
            id="finishedDate"
            type="date"
            label="Finished Date"
            placeholder="yyyy-mm-dd"
            value={finishedDate === null ? '' : finishedDate}
            max="9999-12-31"
            onChange={(e) => onValueChanged('finishedDate', e.target.value, e)}
            disabled={true}
          />
          <CalculatorCol
            id="feedlotCostOfGain"
            type="text"
            label="Feedlot Cost of Gain $/lb"
            value={CFXProFormatNumber(feedlotCostOfGain)}
            disabled={true}
          />
          <CalculatorCol
            id="finishedWeight"
            type="text"
            label="Finished Weight"
            placeholder="lbs"
            value={finishedWeight === null ? 'N/A' : finishedWeight}
            pattern={REGEX.float}
            onChange={(e) =>
              onValueChanged('finishedWeight', e.target.value, e)
            }
            disabled={finishedWeight === null}
          />
          <CalculatorCol
            id="grossCostPerHead"
            type="text"
            label="Gross $/Head"
            value={CFXProFormatNumber(grossCostPerHead)}
            disabled={true}
          />
          <CalculatorCol
            id="projectedMarketPricePerLb"
            type="text"
            label="Projected Market Price/lb"
            value={CFXProFormatNumber(projectedMarketPricePerLb)}
            disabled={true}
          />
        </Row>
        <Row>
          <SyncableButton
            className="cfxpro__btn-default btn btn-default"
            style={{width: '75%', display: 'block', margin: '1em auto'}}
            isSyncing={syncingDefaults}
            didSync={didSaveDefaults}
            baseTitle="Default Numbers"
            onClick={(e) => saveDefaults()}
          />
        </Row>
      </div>
    )
  }
}

class PriceProjectionsResults extends React.Component {
  render() {
    const {projectedMarketPricePerLb = null} = this.props

    return (
      <Row>
        <CalculatorCol
          id="projectedMarketPricePerLb"
          type="text"
          label="Projected Price"
          value={CFXProFormatNumber(projectedMarketPricePerLb)}
          disabled={true}
        />
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/price/projectionsCalculator.js